import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
    palette: {
        primary: {
            light: '#dddddd',
            main: '#4e6e5d',
            dark: '#444444',
            contrastText: '#fff',
        },
        secondary: {
            main: '#4d5057',
        }
    },
});


// .color1 {
//     color: #6f584b
//   }
//   .color2 {
//     color: #4e6e5d
//   }
//   .color3 {
//     color: #1c6e8c
//   }
//   .color4 {
//     color: #4d5057
//   }
//   .color5 {
//     color: #000000
//   }